// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MessageRepo_GetMessagesByChatIdResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /message_repo/getMessagesByChatID
 *
 * Returns a list of messages for a specific chat.
 * Data is proxied from external msgRepoApi service.
 */
import type { MessageRepo_MessageRow } from './MessageRepo_MessageRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MessageRepo_GetMessagesByChatIdResponseDados {
messages: MessageRepo_MessageRow[]
}

export type MessageRepo_GetMessagesByChatIdResponse = ApiResponse<MessageRepo_GetMessagesByChatIdResponseDados>;

registerResponseContract('MessageRepo_GetMessagesByChatIdResponse', {
  messages: {
    type: 'array',
    required: true,
    items: {
      id:         { type: 'string',  required: true },
      chat_id:    { type: 'string',  required: true },
      platform:   { type: 'string',  required: false },
      device_key: { type: 'string',  required: false },
      direction:  { type: 'string',  required: false },
      sender:     { type: 'string',  required: false },
      text:       { type: 'string',  required: false },
      media_type: { type: 'string',  required: false },
      media_url:  { type: 'string',  required: false },
      timestamp:  { type: 'string',  required: false },
    },
  },
})
